export type DefinitionTab = 'strongs' | 'webster';

interface DefinitionTabsProps {
  activeTab: DefinitionTab;
  onChange: (tab: DefinitionTab) => void;
}

const TABS: { id: DefinitionTab; label: string }[] = [
  { id: 'strongs', label: "Strong's" },
  { id: 'webster', label: "Webster's" },
];

/**
 * Left-aligned Strong's / Webster's switch under the pronunciation — one
 * source at a time instead of Webster's scrolled below the fold.
 */
export function DefinitionTabs({ activeTab, onChange }: DefinitionTabsProps) {
  return (
    <div className="strongs-tabs" role="tablist" aria-label="Definition source">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          className={`strongs-tab ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
